import { REFACTOR_URL } from '../../../helpers/env'
import { REFACTOR_API_URL } from '../../auth/constants'
import { API_URL } from '../constants'
import {ICreateLeadReference, ICreateProsthesis, IUpdatePatientProsthesis} from '../reducers'

export const transmitterReferenceService = (
  token: string,
  page: number,
  limit: number, search: string, makerIds: number[]
) => {
  const ENDPOINT: RequestInfo = `${REFACTOR_URL}/transmitter-reference?page=${page}&limit=${limit}&search=${search}${makerIds.map((id) => '&makerIds[]=' + id).join('')}`
  
  return fetchGetData(token, ENDPOINT)
}

export const transmitterReferenceSummaryService = (token: string) => {
  const ENDPOINT: RequestInfo = `${REFACTOR_API_URL}/transmitter-reference/summary`
  return fetchGetData(token, ENDPOINT)
}

export const gammeRangeService = (
  token: string,
  page: number,
  size: number,
) => {
  const ENDPOINT: RequestInfo = `${API_URL}/prosthesis/gamme-range?page=${page}&size=${size}`

  const parameters: RequestInit = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Host: `${API_URL}`,
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  }

  let status = 0

  return fetch(ENDPOINT, parameters)
    .then((response) => {
      status = response.status
      return response.json()
    })
    .then((data) => {
      return { data, status }
    })
    .catch((e) => {
      console.error(e)
    })
}

export const updatePatientProsthesis = (
  token: string,
  infos: IUpdatePatientProsthesis,
  method: string,
) => {
  const ENDPOINT: RequestInfo = `${API_URL}/prosthesis`

  const parameters: RequestInit = {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
    body: JSON.stringify(infos),
  }

  let status = 0

  return fetch(ENDPOINT, parameters)
    .then((response) => {
      status = response.status
      return response.json()
    })
    .then((data) => {
      return { data, status }
    })
    .catch((e) => {
      console.error(e)
    })
}

export const deletePatientProsthesis = (token: string, id: number) => {
  const ENDPOINT: RequestInfo = `${API_URL}/prosthesis/${id}`

  const parameters: RequestInit = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  }

  let status = 0

  return fetch(ENDPOINT, parameters)
    .then((response) => {
      status = response.status
      return response.json()
    })
    .then((data) => {
      return { data, status }
    })
    .catch((e) => {
      console.error(e)
    })
}

export const createProsthesis = (token: string, data: ICreateProsthesis) => {
  const ENDPOINT: RequestInfo = `${REFACTOR_API_URL}/prosthesis/reference`

  return postData(token, ENDPOINT, data)
}

export const createLeadReference = (token: string, data: ICreateLeadReference) => {
  const ENDPOINT: RequestInfo = `${REFACTOR_API_URL}/lead-reference`

  return  postData(token, ENDPOINT, data)
}

export const getProsthesisReferences = (
    token: string,
    limit: number,
    page: number,
    search: string,
    
    gammeIds: string[],
    makerIds: number[],
) => {
  const ENDPOINT: RequestInfo = `${REFACTOR_URL}/prosthesis/reference?page=${page?page:''}&limit=${limit?limit:''}&search=${search}${gammeIds
      .map((id) => '&prosthesisTypes[]=' + id)
      .join('')}${makerIds.map((id) => '&makerIds[]=' + id).join('')}`
  
  return fetchGetData(token, ENDPOINT)
}

export const getLeadsReferences = (token: string, limit: number, page: number, search: string, makerIds: number[]) => {
  const ENDPOINT: RequestInfo = `${REFACTOR_URL}/lead-reference?page=${page}&limit=${limit}&search=${search}${makerIds.map((id) => '&makerIds[]=' + id).join('')}`
  
  return fetchGetData(token, ENDPOINT)
}

export const getProsthesisReferenceSummary = (token: string) => {
  const ENDPOINT: RequestInfo = `${REFACTOR_API_URL}/prosthesis/reference/summary`
  return fetchGetData(token, ENDPOINT)
}

export const getLeadReferenceSummary = (token: string) => {
  const ENDPOINT: RequestInfo = `${REFACTOR_API_URL}/lead-reference/summary`
  return fetchGetData(token, ENDPOINT)
}

export const getLeadConnexions = (token: string) => {
  const ENDPOINT: RequestInfo = `${REFACTOR_API_URL}/lead-reference/connection`
  return fetchGetData(token, ENDPOINT)
}

const fetchGetData = (token: string, endPoint: RequestInfo) => {
  const parameters: RequestInit = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  }
  
  let status = 0
  
  return fetch(endPoint, parameters)
      .then((response) => {
        status = response.status
        return response.json()
      })
      .then((data) => {
        return { data, status }
      })
      .catch((e) => {
        console.error(e)
      })
}

const postData = (token: string, endPoint: RequestInfo, object: object) => {
  const parameters: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
    body: JSON.stringify(object),
  }
  
  let status = 0
  
  return fetch(endPoint, parameters)
      .then((response) => {
        status = response.status
        return response.json()
      })
      .then((data) => {
        console.log(`returned data in service ${JSON.stringify(data)}`)
        return { data, status }
      })
      .catch((e) => {
        console.error(e)
      })
}
